import { useToast } from "primevue/usetoast";

/**
 * Wrapper sobre el Toast de PrimeVue con atajos semánticos.
 * Reemplaza los `alert()` nativos por feedback no bloqueante estilo Apple.
 *
 * Uso:
 *   const toast = useAppToast();
 *   toast.success("Guardado");
 *   toast.error("No se pudo guardar");
 */
export function useAppToast() {
  const toast = useToast();

  const show = (severity, summary, detail, life = 3000) =>
    toast.add({ severity, summary, detail, life });

  return {
    success: (summary, detail) => show("success", summary, detail),
    error: (summary, detail) => show("error", summary, detail, 5000),
    info: (summary, detail) => show("info", summary, detail),
    warn: (summary, detail) => show("warn", summary, detail, 4000),
    raw: toast,
  };
}
